import { Component } from '@angular/core';
import { Dep } from './comm/class/auth';
import { PerfService } from './service/perf.service';
import Clarity from '@microsoft/clarity';


@Component({
  	selector: 'app-root',
  	templateUrl: './app.component.html',
  	styleUrls: ['./app.component.css']
})

export class AppComponent {

  	is_login:boolean = false;
  	selectid : string;
  	user : any ;
	isDesktop: boolean; 
	// Clarity 身分標記去重:同一次頁面載入只送一次
	private clarityIdentifiedId: string = null;

  	constructor(private perf: PerfService) { }

  	ngOnInit(): void {
  	  	this.user = Dep.getData();
  	  	if(!this.user){
  	  	  	this.is_login = false;
  	  	}else{
  	  	  	this.is_login = true;
  	  	}

		this.checkDeviceType();
		window.addEventListener('resize', () => {
			this.checkDeviceType();
		});

		// 擺在 ngOnInit 最後一行:萬一這行出任何意外,isDesktop 已經設好,
		// app.component.html 的 isDesktop 分支(外部經紀 PC/手機版)不會被連累。
		this.identifyClarity();
  	}


  	change_status(newstatus: boolean) {
  	  	this.is_login = newstatus
  	  	this.user = Dep.getData();
  	  	// 登入不重載頁面(signin 是 Dep.setData + router.navigate + emit),ngOnInit 不會重跑,
  	  	// 少了這一處,「剛登入」那段 session 在 Clarity 上會是匿名的。
  	  	this.identifyClarity();
  	}

  	onNotify(xx) { // 相對於 $event, 此處名稱任意
  	  	this.selectid = xx.id;
  	 	 // console.log(xx);
  	}

	checkDeviceType() {
        if (window.innerWidth > 768) { // 假設768px是切換點
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }
    }

	// 把 Clarity 的 session 錄影對應到操作的後台員工。
	// 只在兩處呼叫:ngOnInit(重新整理/直接進站)與 change_status(剛登入)。
	// 刻意不掛在 Dep.getData() —— 那支被呼叫數百次(每個失敗 API 回應 2 次、
	// 每個 app-userandactive 一次,一張 50 列的表就 100 次),而且它是
	// 「無限跳登入頁」那條路徑的正中央,不該為了分析在那裡動刀。
	//
	// ⚠ 守衛必須判 window.clarity,不能用 environment.production:
	//    Clarity.identify() 內部是直接呼叫 window.clarity(...),而 main.ts 的
	//    CLARITY_PROJECT_ID 是該檔的 module 區域變數,這裡讀不到 —— prod build 但 ID 為空時
	//    production 是 true 卻沒有 window.clarity,直呼會 TypeError。
	//    init() 跑過後 window.clarity 立刻是 queue stub,遠端 script 還沒載完的呼叫會排進佇列,不會掉。
	//
	// 只送 employee.id 與 nickname。phone / acc 是登入憑證的一半(後端是
	// `where (phone = ? or acc = ?) and pwd = ?`),絕不外送;name 是員工(含外部經紀)
	// 真實姓名,而 friendlyName 在 Clarity 後台是明文可搜尋的,也不送。
	private identifyClarity(): void {
		try {
			const w: any = window;
			if (typeof w.clarity !== 'function') { return; }  // 本機 ng serve 或 ID 未填 → 靜默跳過
			const u: any = this.user;
			if (!u || !u.id) { return; }                      // 未登入,或登出時 change_status(false)
			const id = 'emp_' + u.id;
			if (this.clarityIdentifiedId === id) { return; }  // 同一次載入只送一次
			this.clarityIdentifiedId = id;
			Clarity.identify(id, undefined, undefined, u.nickname ? String(u.nickname) : id);

			// 角色標籤,給 dashboard 當篩選維度。power_id 是 admin_role.id,值域封閉
			// (0一般/2員工/3主管/4會計/5老闆/6工程師/13行銷主管/14陪聊監察/15經紀妹頭/16外部經紀…),
			// 基數低、零 PII,正好適合 Clarity 的篩選器。
			// 注意兩件事:setTag 的型別是 string | string[],power_id 是 number,不 String() 會被 TS 擋;
			// 而 power_id 可能是 0(一般),所以判定要用 != null,不能用 falsy 判斷。
			const powerId = u.powers ? u.powers.power_id : undefined;
			if (powerId !== undefined && powerId !== null) {
				Clarity.setTag('role_id', String(powerId));
			}
		} catch (e) {
			// 分析壞掉絕不能影響登入流程,靜默失敗
		}
	}

}
